import { useState } from 'react';
import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { ReturnContent, ProductInfoTable, Size } from '@components/products/';

import { Text2 } from '@components/styles/Typography';

const Content = ({ currentTab, details, sku }) => {
    if (currentTab === 'details') {
        return <ProductInfoTable details={details} sku={sku} />;
    }
    if (currentTab === 'returnPolicy') {
        return <ReturnContent />;
    }
    return (
        <SizeTableWrapper>
            <Size />
        </SizeTableWrapper>
    );
};

const MobileDetailsTab = ({ details, sku }) => {
    const { t } = useTranslation();
    const [currentTab, setCurrentTab] = useState('details');

    const onTabChange = (tab) => {
        setCurrentTab(tab);
    };

    return (
        <Detail>
            <ButtonWrapper>
                <Button
                    onClick={() => onTabChange('details')}
                    type="button"
                    data-testid="product-details-button"
                >
                    <Text2 color={currentTab !== 'details' && 'bgGray25'}>
                        {t('productDetails')}
                    </Text2>
                </Button>
                <Button
                    onClick={() => onTabChange('returnPolicy')}
                    type="button"
                    data-testid="return-policy-button"
                >
                    <Text2 color={currentTab !== 'returnPolicy' && 'bgGray25'}>
                        {t('returnPolicy')}
                    </Text2>
                </Button>
                <Button
                    onClick={() => onTabChange('sizePicker')}
                    type="button"
                    data-testid="size-table-button"
                >
                    <Text2 color={currentTab !== 'sizePicker' && 'bgGray25'}>
                        {t('sizeTable')}
                    </Text2>
                </Button>
            </ButtonWrapper>
            <ContentWrapper>
                <Content currentTab={currentTab} details={details} sku={sku} />
            </ContentWrapper>
        </Detail>
    );
};

const Detail = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;
    @media (min-width: 1024px) {
        display: none;
    }
`;

const Button = styled.button`
    background: none;
    cursor: pointer;
    padding: 0 0 5px 0;
    justify-content: space-between;
    border: none;
    border-bottom: ${({ selected, theme }) =>
        selected ? `1px solid ${theme.colors.primary}` : 'none'};
    margin: 0;
    z-index: 3;
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1024px) {
        position: relative;

        margin: 24px 20px;

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background: #bebebe;
            //opacity: 0.3;
            z-index: 2;
        }

        button {
            padding: 0 10px 5px 10px;
        }
    }
`;

const SizeTableWrapper = styled.div`
    margin-left: -30px;
    width: 100vw;

    table {
        width: 100vw;
    }
`;
const ContentWrapper = styled.div`
    @media (max-width: 1024px) {
        padding: 0 30px;
    }
`;

export default MobileDetailsTab;
